import { render, staticRenderFns } from "./PushNotificationsCreate.vue?vue&type=template&id=542941b0"
import script from "./PushNotificationsCreate.vue?vue&type=script&lang=js"
export * from "./PushNotificationsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports